import React from "react";
import parser from "html-react-parser";
import { RiFontSize, RiProductHuntLine } from "react-icons/ri";
import moment from "moment";
const statusColor = (data) => {
  if (data === "Delivered" || data === "CLOSED" || data === "OPEN") {
    return "status-green";
  } else if (data === "Accepted") {
    return "status-blue";
  } else if (data === "Order Placed" || data === "Ready To Process" || data === "CLOSE") {
    return "status-red";
  } else {
    return "status-yellow";
  }
};
const LookupDetailsProduct = ({ details }) => {
  return (
    <div className="overflow-y-auto" style={{ maxHeight: 380 }}>
      <div className="flex md:flex-row flex-col">
        <div className="md:w-1/2 w-full">
          <div className="text-sm mb-1">{details.brand}</div>
          <div className="font-semibold">{details.name}</div>
          <div className="flex items-center">
            {details?.images?.map((img) => (
              <div className="w-16 h-16 bg-zinc-100 p-2">
                <img className="w-full h-full" src={img.url} />
              </div>
            ))}
          </div>
          <div className="text-sm mt-4">
            Mrp: <span className="font-semibold">{details.mrp}</span>
          </div>
          <div className="text-sm">
            Price: <span className="font-semibold">{details.originalPrice}</span>
          </div>

          {details.originalPrice > details.price && (
            <div className="text-sm text-primary">
              Sale Price: <span className="font-semibold">{details.price}</span>
            </div>
          )}

          <div className="mt-2 text-sm flex items-center">
            <RiProductHuntLine className="mr-1" />
            {details?.totalStockCount} in Stock
          </div>
        </div>
        <div className="md:w-1/2 w-full">
          <div className="text-sm">{parser(details?.description)}</div>
        </div>
      </div>
    </div>
  );
};

const LookupDetailsOrders = ({ details }) => {
  return (
    <div className="overflow-y-auto w-full" style={{ maxHeight: 380 }}>
      <div className=" w-full">
        <div className="mb-4 capitalize">
          <div>
            {details[0].orderBy.user.firstName} {details[0].orderBy.user.lastName}
          </div>
        </div>
        {details?.map((o) => (
          <div className="w-full mb-12 border-b border-solid border-gray-200 pb-6 md:w-11/12">
            <div className="text-sm mb-1">{moment(o.createdAt).format("LLL")}</div>
            <div className="text-sm mb-1">{o.invoiceID}</div>
            <div>
              {o.orderProducts?.map((op) => (
                <div className="bg-zinc-100 p-2">
                  <div className="flex items-center justify-between">
                    <div className="text-xs">{op.merchant.name}</div>
                    <div
                      className={`${statusColor(
                        op.orderStatus
                      )} whitespace-nowrap mt-4 ml-0 md:mt-0 md:ml-5`}
                    >
                      {op.orderStatus}
                    </div>
                  </div>
                  <div className="mt-2">
                    {op?.products.map((prod) => (
                      <div className="text-sm bg-white p-4">
                        <div>{prod.product.brand}</div>

                        <div>{prod.product.name}</div>
                        <div className="flex items-center text-xs justify-between">
                          <span>Price - {prod.price} AUD</span>
                          <span>Delivery - {o.deliveryCharges} AUD</span>
                          <span>Discount - {prod.discount} AUD</span>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="pt-3 pb-2 px-2 flex justify-between">
                    <div>
                      <div className="text-xs capitalize">{op.deliverAddress.addressUser}</div>
                      <div className="text-xs">
                        {op.deliverAddress.street}, {op.deliverAddress.suburb},{" "}
                        {op.deliverAddress.stateIso}, {op.deliverAddress.zipcode}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs capitalize">
                        {op.processingStatus.split("_").join(" ")}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
const LookupDetails = (props) => {
  console.log(props.details);
  return (
    <div>
      <div>
        {props.details?.brand ? (
          <LookupDetailsProduct {...props} />
        ) : props.details[0].orderBy ? (
          <LookupDetailsOrders {...props} />
        ) : (
          <div>Unknown Type</div>
        )}
      </div>
    </div>
  );
};

export default LookupDetails;
